import { Routes, Route } from 'react-router-dom';
import { RootRedirect } from './pages/RootRedirect';
import { CampaignLoader } from './pages/CampaignLoader';
import { Step0LandingPage } from './pages/Step0LandingPage';
import { Step1Registration } from './pages/Step1Registration';
import { Step2SelectStore } from './pages/Step2SelectStore';
import { Step3SelectDate } from './pages/Step3SelectDate';
import { Step4Confirmation } from './pages/Step4Confirmation';
import { VoucherRedeemed } from './pages/VoucherRedeemed';
import { ConsultVoucher } from './pages/ConsultVoucher';
import { AnalyticsTracker } from './components/AnalyticsTracker';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <AnalyticsTracker />
      <Routes>
       {/* Root: check active campaign and redirect */}
        <Route path="/" element={<RootRedirect />} />

        {/* Dynamic campaign routes: /:campaignSlug/* */}
        <Route path="/:campaignSlug" element={<CampaignLoader />}>
        <Route index element={<Step0LandingPage />} />
        <Route path="cadastro" element={<Step1Registration />} />
        <Route path="lojas" element={<Step2SelectStore />} />
        <Route path="datas" element={<Step3SelectDate />} />
        <Route path="confirmacao" element={<Step4Confirmation />} />
        <Route path="consultar-voucher" element={<ConsultVoucher />} />
        <Route path="voucher-resgatado" element={<VoucherRedeemed />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
